jQuery(document).ready(function($) {
    $('#change-password-form').submit(function(event) {
        event.preventDefault();
        var newPassword = $('#new-password'); // Використовуємо jQuery-об'єкт для поля нового пароля
        var confirmPassword = $('#new-password-confirm');
        // Отримуємо параметри з URL
        var urlParams = new URLSearchParams(window.location.search);
        var messageParam = urlParams.get('message'); // Отримуємо значення параметра "message" з URL

        if (messageParam) {
            var email = messageParam; // Записуємо весь email у змінну email
        }


        var isFormValid = true;
        var errorMessage = '';
        // Перевіряємо заповненість полів
        if (!newPassword.val() && !confirmPassword.val()) {
            errorMessage = localized_texts.enter_fields;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            newPassword.addClass('error');
            confirmPassword.addClass('error');
            isFormValid = false;
        } else if(!newPassword){
            errorMessage = localized_texts.enter_new_password;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            newPassword.addClass('error');
            isFormValid = false;
        } else if(!confirmPassword) {
            errorMessage = localized_texts.confirm_password;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            confirmPassword.addClass('error');
            isFormValid = false;
        }

        if (newPassword.val() !== confirmPassword.val()) {
            errorMessage = localized_texts.passwords_do_not_match;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            confirmPassword.addClass('error');
            newPassword.addClass('error');
            isFormValid = false;
        }


        if (isFormValid) {
            $.ajax({
                type: 'POST',
                url: ajax_change.ajax_url, // URL адреса для AJAX запиту
                data: {
                    action: 'custom_change_password',
                    new_password: newPassword.val(),
                    user_email: email,
                },
                success: function (response) {
                    var jsonResponse = JSON.parse(response);
                    if (jsonResponse.success){
                        removeErrorClass();
                        displayNotification(jsonResponse.message, jsonResponse.success, 2);
                        setTimeout(function() { // Додаємо затримку перед оновленням HTML
                            window.location.href = '/';
                        }, 2100); // Затримка 3.1 секунди
                    } else{
                        displayNotification(jsonResponse.message, jsonResponse.success, 3);
                        if (jsonResponse.field) {
                            removeErrorClass();
                            $('#' + jsonResponse.field).addClass('error');
                        }
                    }
                }
            });
        }
    });
    function displayNotification(message, isSuccess, durationInSeconds = 15) {
        var notificationElement = $('.modal_notification');
        notificationElement.text(message).addClass('visible');
        if (!isSuccess) {
            notificationElement.addClass('error');
        } else {
            notificationElement.removeClass('error').addClass('success');
        }
        setTimeout(function() {
            notificationElement.removeClass('visible error success');
        }, durationInSeconds * 1000); // 15 секунд
    }

    function removeErrorClass() {
        var errorElement = document.querySelectorAll('.modal_form .error'); // Отримуємо всі елементи введення з класом помилки
        errorElement.forEach(function(input) { // Ітеруємося по кожному елементу
            input.classList.remove('error'); // Видаляємо клас помилки
        });
    }
});


